import { useEffect, useState } from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "./Loading";
import { jwtDecode } from "jwt-decode";
import { motion } from "framer-motion";

export default function ReciboUsuarioCliente() {
  const [recibos, setRecibos] = useState([]);
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState("");
  const [naoHaRecibos, setNaoHaRecibos] = useState(false);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  async function mostrarRecibos() {
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("token"));
    if (token) {
      const dadosDoLocalStorage = jwtDecode(token);
      try {
        const dadosUsuario = await axios.get(
          `https://api-eyazs-production-8f74.up.railway.app/usuario/${dadosDoLocalStorage.idUsuario}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const dadosRecibo = await axios.get(
          `https://api-eyazs-production-8f74.up.railway.app/recibos/${dadosUsuario.data.idUsuario}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (Array.isArray(dadosRecibo.data) && dadosRecibo.data.length > 0) {
          setRecibos(dadosRecibo.data);
        } else {
          setNaoHaRecibos(true);
        }
        setUsuario(dadosUsuario.data.name);
      } catch (erro) {
        console.log(erro);
      } finally {
        setLoading(false);
      }
    }
  }

  useEffect(() => {
    mostrarRecibos();
  }, []);

  return (
    <div className="flex flex-col justify-between min-h-screen">
      <div className="bg-blue-500 z-10 sticky top-0">
        <NavBar />
      </div>

      {loading ? (
        <Loading />
      ) : naoHaRecibos ? (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex justify-center items-center h-1/2 px-4"
        >
          <div className="text-center my-6 bg-white p-6 sm:p-8 rounded-lg shadow-lg border-t-2 w-full max-w-sm mx-auto">
            <h1 className="text-2xl sm:text-3xl font-semibold text-red-600 mb-4">
              Não há recibos disponíveis
            </h1>
            <p className="text-base sm:text-lg text-gray-700 mb-6">
              Infelizmente, não encontramos nenhum recibo para exibir. Tente novamente mais tarde ou verifique sua conexão.
            </p>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => navigate(-1)}
              className="bg-blue-500 text-white font-bold py-2 px-6 rounded-lg hover:bg-blue-400 transition duration-300 ease-in-out"
            >
              Voltar
            </motion.button>
          </div>
        </motion.div>
      ) : (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="w-full max-w-6xl border rounded-xl h-auto mx-auto my-8 px-4 sm:px-8 z-0"
        >
          <div className="flex flex-col m-4">
            <h2 className="mb-4 text-gray-600 text-lg sm:text-xl text-center sm:text-left">
              Histórico de Pagamento do Usuário{" "}
              <span className="uppercase font-semibold text-gray-900">
                {usuario}
              </span>
            </h2>

            <div className="overflow-x-auto">
              <table className="border border-gray-200 w-full table-auto text-sm sm:text-base">
                <thead className="bg-gray-100">
                  <tr className="text-gray-500">
                    <th className="border text-center py-2 px-2">ID</th>
                    <th className="border text-center py-2 px-2">Data</th>
                    <th className="border text-center py-2 px-2">Método de Pagamento</th>
                    <th className="border text-center py-2 px-2">Montante</th>
                    <th className="border text-center py-2 px-2">Recibo</th>
                  </tr>
                </thead>
                <tbody className="text-gray-600">
                  {recibos.map((recibo, i) => {
                    const dataTransacao = new Date(recibo.dataTransacao);
                    const dia = String(dataTransacao.getDate()).padStart(2, "0");
                    const mes = String(dataTransacao.getMonth() + 1).padStart(2, "0");
                    const ano = dataTransacao.getFullYear();
                    const dataFormatada = `${dia}/${mes}/${ano}`;

                    return (
                      <motion.tr
                        key={recibo.idRecibo}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: i * 0.05 }}
                        className="border"
                      >
                        <td className="text-center border py-2 px-2">{i + 1}</td>
                        <td className="text-center border py-2 px-2">{dataFormatada}</td>
                        <td className="text-center border py-2 px-2">{recibo.meioPagamento}</td>
                        <td className="text-center border py-2 px-2">{recibo.valor}</td>
                        <td className="border text-center py-2 px-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-6 h-6 mx-auto cursor-pointer hover:text-blue-500"
                            onClick={() => navigate(`/recibo/${recibo.idRecibo}`)}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                            />
                          </svg>
                        </td>
                      </motion.tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </motion.div>
      )}
      <div className="bg-blue-500 mt-auto">
        <Footer />
      </div>
    </div>
  );
}
